<template>
    <div>
        <!--<div class="dx-field">
            <router-link to="/login-form"><a>Log In</a></router-link>
        </div>-->
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class=" dinesafe-label red-font">Your subscription is inactive</div>
        </div>
        <div class='back-button'>
            <DxButton 
                icon="back"
                ref="btnBackRef" 
                type="normal"
                text="Back to Login"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>   

        <!--<div class='dx-field inactive-subscription center'>Your subscription is inactive.</div>-->
        
        <div class='center'>
            <DxButton 
                ref="btnResubscribeRef" 
                type="default"
                text="Resubscribe"
                styling-mode="outlined" 
                width="180"
                @click="btnResubscribe"
            />
        </div>
    </div>
</template>
 
<script>
    import DxTextBox from "devextreme-vue/text-box";
    import {DxButton} from 'devextreme-vue';
    import DxValidationGroup from "devextreme-vue/validation-group";
    import DxValidator, { DxEmailRule, DxRequiredRule } from "devextreme-vue/validator";
    import DxValidationSummary from 'devextreme-vue/validation-summary';

    export default {
        components: {
            DxTextBox,
            DxButton,
            DxValidationGroup,
            DxValidator,
            DxRequiredRule,
            DxValidationSummary,
            DxEmailRule,
        },
        props: {
           
        },
        data() {
            return {

            }
        },
        methods:{
            btnResubscribe(data, actions) {
                //Navigate to the resubscribe page
                this.$router.push("/resubscribe");
            },
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            }
        }
    }
</script>

<style scoped>
    .center{
        display: flex; 
        justify-content: center;

        margin-top: 20px;
    }

    .back-button{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>